{
  "page": {
    "title": "Հաշվետվություններ",
    "ariaLabel": "Հաշվետվությունների տեսակներ"
  },
  "filters": {
    "timeRange": "Ժամանակահատված",
    "employee": "Աշխատակից",
    "allEmployees": "Բոլոր աշխատակիցները",
    "employeeRequired": "Աշխատակից *",
    "selectEmployee": "Ընտրեք աշխատակից…"
  },
  "templates": {
    "attendanceSummary": {
      "label": "Ներկայության ամփոփում",
      "description": "Ամենօրյա ներկայության ամփոփ տվյալ՝ մուտքի/ելքի ժամերով և յուրաքանչյուր աշխատակցի աշխատած ժամերով։"
    },
    "payroll": {
      "label": "Աշխատավարձ",
      "description": "Աշխատավարձի մանրամասնում՝ ժամերով, դրույքաչափերով և ընդհանուր վճարով յուրաքանչյուր աշխատակցի համար։"
    },
    "dailyTimesheet": {
      "label": "Օրական տաբել",
      "description": "Յուրաքանչյուր աշխատակցի յուրաքանչյուր օրվա մանրամասն գրանցումների հաջորդականություն։"
    },
    "lateAbsent": {
      "label": "Ուշացումներ և բացակայություններ",
      "description": "Ժամանակահատվածում ուշացած կամ բացակայած աշխատակիցները։"
    },
    "overtime": {
      "label": "Արտաժամ",
      "description": "Ընտրված ժամանակահատվածի արտաժամյա ժամերի և վճարի ամփոփում։"
    },
    "employeeActivity": {
      "label": "Աշխատակցի ակտիվություն",
      "description": "Ամբողջական ակտիվության մատյան՝ ներառելով յուրաքանչյուր աշխատակցի բոլոր գրանցումները։"
    },
    "attendanceGrid": {
      "label": "Հաճախելիության աղյուսակ",
      "description": "Ամսական մատրից՝ յուրաքանչյուր աշխատակցի աշխատած ժամերով, արձակուրդային, բացակայության օրերով և ներկայության տվյալներով։"
    },
    "hiring": {
      "label": "Ընդունելություն",
      "description": "Ընտրված ժամանակահատվածում աշխատանքի ընդունված աշխատակիցները՝ ընդունման ամսաթվով և կոնտակտային տվյալներով։"
    }
  },
  "export": {
    "csv": "Արտահանել CSV",
    "excel": "Արտահանել Excel",
    "pdf": "Արտահանել PDF",
    "downloadFailed": "Ներբեռնումը ձախողվեց: Խնդրում ենք կրկին փորձել:",
    "dismiss": "Փակել"
  },
  "attendanceGrid": {
    "monthLabel": "Ամիս",
    "employeeColumn": "Աշխատակից",
    "cell": {
      "vacation": "Ա",
      "leave": "Բ",
      "holiday": "Տ",
      "present": "Ն"
    },
    "legend": {
      "worked": "Աշխատած (սկիզբ–ավարտ)",
      "vacation": "Արձակուրդ",
      "leave": "Բացակա",
      "holiday": "Տոն",
      "off": "Ոչ աշխատանքային օր",
      "present": "Ներկա",
      "workedHours": "Աշխատած (ժամեր աշխատավայրում)"
    },
    "view": {
      "label": "Տեսք",
      "times": "Եկավ / գնաց",
      "hours": "Ժամեր աշխատավայրում"
    }
  },
  "preview": {
    "selectEmployee": "Ընտրեք աշխատակից՝ հաշվետվության նախադիտման համար",
    "selectEmployeeHint": "Օգտագործեք ֆիլտրերի վահանակի աշխատակիցների ցուցակը:",
    "failedToLoad": "Չհաջողվեց բեռնել հաշվետվության տվյալները",
    "failedToLoadHint": "Ստուգեք կապը և կրկին փորձեք:",
    "noData": "Ընտրված ժամանակահատվածի համար տվյալ չկա",
    "noDataHint": "Փոխեք ամսաթվերի միջակայքը կամ աշխատակցի ֆիլտրը և կրկին փորձեք:",
    "truncatedRows": "Ցուցադրված է առաջին 50-ը {{total}}-ից: Բոլոր տվյալները տեսնելու համար կատարեք արտահանում:"
  },
  "advance": {
    "addButton": "Ավելացնել կանխավճար",
    "dialogTitle": "Նոր կանխավճար",
    "dateNotice": "Կանխավճարը գրանցվում է այսօրվա ամսաթվով։",
    "employeeLabel": "Աշխատակից",
    "employeePlaceholder": "Ընտրեք աշխատակցին",
    "amountLabel": "Գումար (AMD)",
    "noteLabel": "Նշում (կամընտիր)",
    "errors": {
      "employeeRequired": "Ընտրեք աշխատակցին։",
      "amountInvalid": "Մուտքագրեք 0-ից մեծ գումար։"
    },
    "toasts": {
      "created": "Կանխավճարը գրանցվել է։",
      "createFailed": "Չհաջողվեց գրանցել կանխավճարը։ Կրկին փորձեք։",
      "deleted": "Կանխավճարը ջնջվել է։",
      "deleteFailed": "Չհաջողվեց ջնջել կանխավճարը։ Կրկին փորձեք։"
    },
    "listTitle": "Կանխավճարներ — {{name}}",
    "listEmpty": "Այս ժամանակահատվածում կանխավճարներ չկան։",
    "listTotal": "Ընդամենը",
    "deleteAria": "Ջնջել կանխավճարը",
    "confirmDelete": "Ջնջե՞լ այս կանխավճարը։",
    "dateLabel": "Ամսաթիվ"
  },
  "columnToggle": {
    "hide": "Թաքցնել սյունակը",
    "show": "Ցուցադրել սյունակը"
  },
  "groups": {
    "collapse": "Ծալել սյունակները",
    "expand": "Բացել սյունակները",
    "late": {
      "title": "Ուշացում",
      "hours": "Ժամեր",
      "deduction": "Պահում (AMD)"
    },
    "earlyLeave": {
      "title": "Վաղ հեռանալ",
      "hours": "Ժամեր",
      "deduction": "Պահում (AMD)"
    },
    "absence": {
      "title": "Բացակայություն / չվճարվող",
      "days": "Օրեր",
      "deduction": "Պահում (AMD)"
    },
    "overtime": {
      "title": "Արտաժամ",
      "hours": "Ժամեր",
      "rate": "Դրույք",
      "pay": "Վճար (AMD)"
    }
  },
  "inlineEdit": {
    "saved": "Պահպանվել է։",
    "saveFailed": "Չհաջողվեց պահպանել։ Կրկին փորձեք։",
    "spSalaryHint": "Կիրառվում է {{month}}-ից սկսած․ նախորդ ամիսների ՍՊԸ-ն չի փոխվում։"
  }
}
